var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "waiveFeeModal",
      "visible": _vm.show,
      "centered": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('onCloseModal');
      }
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        var _vm$row;

        return [_c('h5', {
          staticClass: "modal-title"
        }, [_vm._v(" " + _vm._s(_vm.type === "group" && ((_vm$row = _vm.row) === null || _vm$row === void 0 ? void 0 : _vm$row.waive_status) == 1 ? "Add Enrollment Fee" : "Waive Fee") + " ")]), _c('button', {
          staticClass: "close",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.$emit('onCloseModal');
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])];
      },
      proxy: true
    }])
  }, [_c('div', [_c('h6', [_vm._v(" " + _vm._s(_vm.row && _vm.row.waive_status == 1 ? "Are you sure you want to add enrollment fee ?" : "Are you sure you want to waive enrollment fee ?") + " ")])]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "mb-2",
    attrs: {
      "for": ""
    }
  }, [_vm._v("Reason"), _c('span', {
    staticClass: "required ms-1"
  })]), _c('br'), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.reason,
      expression: "reason"
    }],
    staticClass: "waive-field",
    attrs: {
      "name": "",
      "id": "",
      "rows": "5",
      "width": "100%"
    },
    domProps: {
      "value": _vm.reason
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.reason = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "d-flex justify-content-end align-items-center gap-2"
  }, [_c('button', {
    staticClass: "btn univ-btn sendBtn mb-0 mt-0 w-auto ps-4 pe-4",
    on: {
      "click": _vm.handleWaive
    }
  }, [_vm._v(" Yes ")]), _c('button', {
    staticClass: "btn cancel-btn btn-secondary",
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" Close ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }